<template>
  <i class="iconfont" :class="icon" :style="iconStyle"></i>
</template>
<script>
export default {
  name: 'iconfont',
  components: {},
  data() {
    return {
    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: [String, Number],
      default: 12
    },
    color: {
      type: String,
      default: '#333'
    },
  },
  computed: {
    iconStyle() {
      let size = this.size.endsWith('px') ? this.size : `${this.size}px`
      return `font-size: ${size};color: ${this.color};`
    }
  }
}
</script>


<style lang='less' scoped>
  * {
    box-sizing: border-box;
  }
  .iconfont {
    font-size: 1em;
    font-weight: normal;
  }
</style>